// ##### 25-02-05 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useMessages } from '../../../../helpers/messages';
// ##### 25-05-21 Komarov
import LocalizationNavLink from '../../../Library/Localization/LocalizationNavLink';
import CooperationMobile from './CooperationMobile';
import RequestsMobile from './RequestsMobile';

// ##### Komarov 2025-07-14
const MobileMenuTextItems = ({
  // ##### 24-08-08 Komarov
  sitepage_type,
  isWhiteLabelSet,
  companyCipher,
  sidebarListWidth,
}) => {
  // ##### 24-06-20 Komarov
  const pagesFromLocalStorageArray = Object.values(useMessages()).filter(
    page =>
      parseInt(sitepage_type.sitepage_type_id) ===
      parseInt(page.sitepage_type_id) &&
      parseInt(sitepage_type.sitepage_type_id) !== 7 &&
      parseInt(page.id) !== 198
  );

  // ##### 24-08-08 Komarov
  const cooperation = pagesFromLocalStorageArray.find(
    page => page.name === 'Cooperation'
  );
  const requests = pagesFromLocalStorageArray.find(
    page => page.name === 'Requests'
  );

  // ##### 24-08-08 Komarov
  return pagesFromLocalStorageArray.length > 0 ? (
    <>
      {pagesFromLocalStorageArray
        .filter(
          page =>
            ![
              'Clients',
              'Suppliers',
              'Group Request',
              'Cooperation',
              'Requests',
            ].includes(page.name)
        )
        .map(page => {
          return (
            // ##### 25-04-21 Komarov
            <LocalizationNavLink
              to={
                (isWhiteLabelSet &&
                  `/ref${companyCipher}/sitepages/?name=${page.name}&spid=${page.id}`) ||
                `/sitepages/?name=${page.name}&spid=${page.id}`
              }
              key={uniqueId()}
            >
              {/* ##### 26-06-30 Komarov */}
              <h4>{parse(page.title?.[0]?.text ?? '')}</h4>
            </LocalizationNavLink>
          );
        })}
      <CooperationMobile
        pages={pagesFromLocalStorageArray.filter(page =>
          ['Clients', 'Suppliers'].includes(page.name)
        )}
        // ##### 26-06-30 Komarov
        title={cooperation?.title?.[0]?.text ?? ''}
        isWhiteLabelSet={isWhiteLabelSet}
        companyCipher={companyCipher}
        sidebarListWidth={sidebarListWidth}
      />
      {/* ##### 24-08-07 Komarov */}
      <RequestsMobile
        pages={pagesFromLocalStorageArray.filter(page =>
          ['Group Request'].includes(page.name)
        )}
        // ##### 26-06-30 Komarov
        title={requests?.title?.[0]?.text ?? ''}
        isWhiteLabelSet={isWhiteLabelSet}
        companyCipher={companyCipher}
        sidebarListWidth={sidebarListWidth}
      />
    </>
  ) : null;
};

export default MobileMenuTextItems;
